import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merges Tailwind classes without duplicates (the shadcn/ui convention). */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
